import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	toolsButtonLabel: {
		id: 'fastshift-portal.tools-menu.button-label',
		defaultMessage: 'Tools',
		description: 'Label for the tools menu button in the FastShift Portal top navigation',
	},
	csProfilerToolLabel: {
		id: 'fastshift-portal.tools-menu.cs-profiler-label',
		defaultMessage: 'CS Profiler',
		description: 'Label for the CS Profiler option in the FastShift Portal tools menu',
	},
});
